var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formily-copy"},[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('i',{staticClass:"crm-Icon_copy",on:{"click":_vm.copyClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }